/* tslint:disable:no-any */
import { get } from 'lodash';

import { IErrorTrackingDetails } from '../interfaces/error-tracking-details.interface';

import { MobizHttpErrorResponse } from './mobiz-http-error-response.do';
import { SerializableObject } from './serializable-object';

/**
 * @deprecated switch to MobizError from the error-proxy sub-package.
 * @see MobizError
 */
export class MobizRuntimeError<OrigErr = any> extends SerializableObject implements Error {
  public readonly name: string;
  public readonly message: string;
  public readonly stack: string;

  public trackingDetails: IErrorTrackingDetails | undefined;

  constructor(
    public readonly originalError: OrigErr,
    public readonly location: string,
  ) {
    super();
    this.message = this.getMessage();
    this.name = this.getName();
    this.stack = this.getStack();
    this.trackingDetails = this.getTrackingDetails();
  }

  private getMessage(): string {
    if (this.originalError instanceof MobizHttpErrorResponse && this.originalError.info) {
      const message: string | undefined = this.originalError.info.getMessage();
      if (message && message.length) {
        return message;
      }
    }
    return get(this.originalError, 'message', 'Please contact your administrator.');
  }

  private getName(): string {
    let errorName: string = get(this.originalError, 'name', 'Unknown Error');
    if (this.originalError instanceof MobizHttpErrorResponse && this.originalError.info) {
      const name: string | undefined = this.originalError.info.getName();
      if (name && name.length) {
        errorName = name;
      }
    }
    const maxNameLength: number = 256;
    if (errorName && errorName.length > maxNameLength) {
      // NOTE: Sometimes, the error name is actually a stack trace and we only show the first line.
      const errorNameLines = errorName.split('\n');
      if (errorNameLines.length > 1) {
        errorName = errorNameLines[0];
      }
    }
    return errorName;
  }

  private getStack(): string {
    // NOTE: The string of the stack trace only includes function calls and file line information.
    const stack: unknown = get(this.originalError, 'stack');
    return stack && `${stack}`;
  }

  private getTrackingDetails(): IErrorTrackingDetails | undefined {
    if (this.originalError instanceof MobizHttpErrorResponse && this.originalError.info) {
      return {
        referenceId: this.originalError.info.trackingId || undefined,
        referenceUrl: this.originalError.info.errorReference || undefined,
      };
    }
    return undefined;
  }

}
